import { api } from "@/lib/api";

export interface CreateVehiclePayload {
  type?: string;
  plateNumber: string;
  color?: string;
  modelId?: string;
  makeId?: string;
  customerId: string;
  year?: number;
}

export interface UpdateVehiclePayload {
  type?: string;
  plateNumber: string;
  color?: string;
  notes?: string | null;
  makeId?: string;
  modelId?: string;
  year?: number;
}

export const vehicleService = {
  async createVehicle(payload: CreateVehiclePayload) {
    const response = await api.post("/vehicle", payload);
    return response.data.data;
  },

  async getAllVehicles() {
    const response = await api.get("/vehicle");
    return response.data.data;
  },

  async updateVehicle(id: string, payload: UpdateVehiclePayload) {
    const response = await api.put(`/vehicle/${id}`, payload);
    return response.data.data;
  },

  async deleteVehicle(id: string) {
    const response = await api.delete(`/vehicle/${id}`);
    return response.data.data;
  },
};
